import React, { useEffect, useRef } from 'react';
import * as Icons from 'lucide-react';
import { FileText, CornerDownLeft } from 'lucide-react';

/**
 * Ein einzelner Command-Eintrag in der Liste.
 * Klick (oder Enter bei highlight=true) triggert onSelect.
 */
export default function CommandItem({
  command,
  highlighted,
  onSelect,
  onHover,
}) {
  const ref = useRef(null);

  // Ins View scrollen, wenn per Keyboard markiert
  useEffect(() => {
    if (highlighted && ref.current) {
      ref.current.scrollIntoView({ block: 'nearest' });
    }
  }, [highlighted]);

  const Icon = Icons[command.icon] || FileText;

  return (
    <button
      ref={ref}
      type="button"
      onMouseEnter={onHover}
      onClick={onSelect}
      className={
        'group w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left text-sm transition-colors ' +
        (highlighted
          ? 'bg-primary-50 dark:bg-slate-800 text-gray-900 dark:text-white'
          : 'text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-800/60')
      }
    >
      <div
        className={
          'w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors ' +
          (highlighted
            ? 'bg-white dark:bg-slate-700 text-primary-600 dark:text-primary-400'
            : 'bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-slate-400 group-hover:text-primary-600 dark:group-hover:text-primary-400')
        }
      >
        <Icon size={16} />
      </div>

      <div className="flex-1 min-w-0">
        <div className="truncate font-medium">{command.title}</div>
        {command.subtitle && (
          <div className="truncate text-xs text-gray-400 dark:text-slate-500">
            {command.subtitle}
          </div>
        )}
      </div>

      <div className="flex items-center gap-1.5 flex-shrink-0">
        {command.shortcut && (
          <kbd className="hidden sm:inline-block text-[10px] font-mono font-semibold text-gray-400 dark:text-slate-500 bg-gray-100 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded px-1.5 py-0.5">
            {command.shortcut}
          </kbd>
        )}
        {highlighted && (
          <CornerDownLeft
            size={14}
            className="text-gray-400 dark:text-slate-500"
            aria-label="Enter zum Waehlen"
          />
        )}
      </div>
    </button>
  );
}
